<template>
  <div ref="root" :class="$style['adl-chart-bar-group']">
    <slot name="tooltipText"></slot>
    <mce-layout
      :plot-width="width"
      :plot-height="height"
      :axis-left-width="axisLeftWidth"
      :axis-right-width="axisRightWidth"
      :class="$style['axis-scroll']"
    >
      <template #legend-top>
        <mce-legend hideTopBorder :horizontal="true">
          <mce-legend-item
            v-for="(d, i) in legendItems"
            :key="i"
            :label="d"
            :key-type="legendKeyType"
            :color="color[i]"
            :class="$style[legendItemsDisable[i]]"
            @click.native="disableLegend(i)"
          ></mce-legend-item>
        </mce-legend>
      </template>
      <template #axis-left>
        <mce-y-axis
          scale-type="linear"
          :labels="{ unit: 'AUD', axis: labelNameY }"
          :domain="domainY"
          :range="rangeY"
          :label-format="FormatCurrency"
          :tickQuantity="tickQuantityY"
        >
          <template v-if="isHideFirstTick" #mce-y-tick-0
            ><span></span
          ></template>
        </mce-y-axis>
      </template>
      <template #axis-bottom>
        <div ref="xAxisParent">
          <mce-x-axis
            scale-type="band"
            :labels="{ axis: 'Year' }"
            :domain="domainX"
            :range="changeRangeX"
          ></mce-x-axis>
        </div>
      </template>
      <template #default>
        <mce-pointer v-model="mouse"></mce-pointer>
        <mce-grid
          scale-type-y="linear"
          :domain-y="domainY"
          :range-x="changeRangeX"
          :range-y="rangeY"
          :tickQuantityY="tickQuantityY"
          :outlines="{ top: true, bottom: true }"
        ></mce-grid>

        <adl-bar-plot-vertical-grouped
          :color="chartColor"
          :data="chartData"
          :dataFocused="focusedData"
          :domain-x="domainXLabel"
          :paddingInner="0.3"
          :domain-y="domainY"
          :range-x="changeRangeX"
          :range-y="rangeY"
          :mouse="mouse"
          @mousemove-plot="onMousemovePlotBar"
          @mouseleave-plot="focusedData = []"
        ></adl-bar-plot-vertical-grouped>
      </template>
    </mce-layout>
  </div>
</template>

<script>
import Vue from "vue";
import MceLayout from "@mce/layout";
import MceYAxis from "@mce/y-axis";
import MceXAxis from "@mce/x-axis";
import McePointer from "@mce/pointer";
import { MceLegend, MceLegendItem, MceLegendGroup } from "@mce/legend";
import AdlBarPlotVerticalGrouped from "./adl-bar-plot-vertical-grouped.vue";
import MceGrid from "@mce/grid";
import { format } from "d3-format";
import _ from "lodash";
export default Vue.extend({
  name: "AdlChartBarGroup",
  components: {
    MceLayout,
    MceYAxis,
    MceXAxis,
    MceGrid,
    MceLegend,
    MceLegendItem,
    MceLegendGroup,
    AdlBarPlotVerticalGrouped,
    McePointer,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    color: {
      type: Array,
      default: () => [],
    },

    legendItems: {
      type: Array,
      default: () => [],
    },
    legendKeyType: {
      type: String,
      default: () => "bar",
    },
    rangeX: {
      type: Array,
      required: true,
    },
    currencyFormat: {
      type: String,
      required: true,
    },
    rangeY: {
      type: Array,
      required: true,
    },
    domainX: {
      type: Array,
      required: true,
    },
    domainY: {
      type: Array,
      required: true,
    },
    labelNameY: {
      type: String,
    },
    tickQuantityY: {
      type: Number,
      default: 5,
    },

    axisLeftWidth: {
      type: Number,
    },
    axisRightWidth: {
      type: Number,
    },
    height: {
      type: Number,
    },
    width: {
      type: Number,
    },

    toolTipWidth: {
      type: Number,
    },
    isHideFirstTick: {
      type: Boolean,
    },
  },
  data() {
    return {
      mouse: null,
      mouseDataBar: {},
      disableClassName: "disable-legend",
      cursorPointerClassName: "legend-hover",
      currentSelectedLegendIndex: -1,
      paddingLeft: 50,
      focusedData: [],
      legendItemsDisable: [...Array(this.legendItems.length).keys()],
      hoverHeight: 0,
    };
  },
  computed: {
    chartColor() {
      let chartColor = _.cloneDeep(this.color);
      for (let j = this.legendItemsDisable.length - 1; j >= 0; j--) {
        if (this.legendItemsDisable[j] == this.disableClassName) {
          chartColor.splice(j, 1);
        }
      }
      return chartColor;
    },
    chartData() {
      let returnData = _.cloneDeep(this.data);
      for (let i = 0; i < returnData.length; i++) {
        for (let j = this.legendItemsDisable.length - 1; j >= 0; j--) {
          if (this.legendItemsDisable[j] == this.disableClassName) {
            returnData[i].value.splice(j, 1);
          }
        }
      }
      return returnData;
    },
    changeRangeX() {
      return [0, this.width];
    },
    domainXLabel: function () {
      return this.domainX;
    },
    FormatCurrency: function () {
      return format(this.currencyFormat);
    },
  },
  watch: {
    mouse: {
      async handler() {
        if (this.mouse) {
          this.$emit(
            "setTooltipData",
            this.mouseDataBar,
            this.legendItemsDisable.filter((sr) => sr != this.disableClassName),
            this.mouse
          );
        } else {
          this.$emit("setTooltipData", null, null, null);
        }
      },
    },
  },

  methods: {
    disableLegend(index) {
      let className = this.legendItemsDisable[index];
      if (className == this.disableClassName) {
        this.legendItemsDisable[index] = index;
      } else {
        this.legendItemsDisable[index] = this.disableClassName;
      }
      this.legendItemsDisable = this.legendItemsDisable.concat();
    },
    onMousemovePlotBar(mouseData) {
      const { data } = mouseData;
      this.focusedData = [data._itemId];
      this.mouseDataBar = data;
    },
  },
});
</script>

<style lang="scss" module>
.adl-chart-bar-group {
  .mce-bar-plot-vertical__bar--not-focused {
    opacity: 0.6 !important;
  }
  .mce-grid__y-tick {
    stroke-dasharray: 0 !important;
  }
  .mce-axis-x__tick {
    text-align: left !important;
  }
  .legend-hover {
    cursor: pointer;
  }
  .disable-legend {
    opacity: 0.5;
  }
  .axis-scroll {
    overflow: auto;
    overflow-y: hidden;
  }
  li {
    cursor: pointer !important;
  }
}
</style>
